export default "__VITE_ASSET__CdkqClAT__"